export default function Filter({
  setType,
  type,
  productName,
  setProductName,
  handleReset,
  setPageNumber,
}) {
  let timeOutId;
  const handleSearch = (value) => {
    if (timeOutId) {
      clearTimeout(timeOutId);
    }
    timeOutId = setTimeout(() => {
      setProductName(value);
    }, 100);
  };
  return (
    <>
      <div>
        <input
          className="textbox"
          type="text"
          placeholder="Search with name"
          value={productName}
          onChange={(e) => {
            handleSearch(e.target.value);
            setPageNumber(1);
          }}
        />
        <button className="search_button">Search</button>
      </div>

      <div className="form-group radio">
        <label>Type</label>
        <div className="radio_group">
          <input
            type="radio"
            value="income"
            name="type"
            checked={type === "income"}
            onChange={() => {
              setType("income");
              setPageNumber(1);
            }}
          />
          <label>Income</label>
        </div>
        <div className="radio_group">
          <input
            type="radio"
            value="expense"
            name="type"
            placeholder="Expense"
            checked={type === "expense"}
            onChange={() => {
              setType("expense");
              setPageNumber(1);
            }}
          />
          <label>Expense</label>
        </div>
      </div>
      <button
        className="search_button btn-expand"
        onClick={() => handleReset()}
      >
        Clear All Filter
      </button>
    </>
  );
}
